import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  description: string
  onSubmit: () => void
  onCloseDimensionsAlertModal: () => void
}

const DimensionsAlertModal = ({ description, onSubmit, onCloseDimensionsAlertModal }: Props) => {
  return (
    <Modal
      illustration="alert"
      title={i18n.t('finance.employee_dimensions_info.modals.alert.title')}
      description={description}
      onSubmit={onSubmit}
      onClose={onCloseDimensionsAlertModal}
      footer={
        <>
          <Button type="secondary" onClick={onCloseDimensionsAlertModal}>
            {i18n.t('finance.employee_dimensions_info.modals.alert.buttons.keep')}
          </Button>
          <Button submit>
            {i18n.t('finance.employee_dimensions_info.modals.alert.buttons.review')}
          </Button>
        </>
      }
    />
  )
}

export default DimensionsAlertModal
